import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import {
  GetTrafficMarshal,
  UpdateTrafficMarshalDetails,
  CreateTrafficMarshalDeatails, GetOperationTypes
} from "../../Apis/TrafficMarshal";
import TableComponent from "../../Common/TableComponent/tableComponent";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { TableLoader } from "../../Common/ShimmerLoader";
import { withTranslation } from "react-i18next";
import * as XLSX from "xlsx"; // Import XLSX library for Excel operations
import ExcelJS from "exceljs";


const TrafficMarshal = ({ t }) => {
  const [lgShow, setLgShow] = useState(false);
  //const [status, setStatus] = useState("")
  const [operations, setOperations] = useState([])
  const [editTrafficMarshalData, setEditTrafficMarshalData] = useState("");
  const [isOptionsLoading, setIsOptionsLoading] = useState(true);
  const [orginalZones, setOriginalZones] = useState([]);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [sortConfig, setSortConfig] = useState(null);
  const [filterOriginalTrafficMarshalData, setFilterOriginalTrafficMarshalData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [sortedData, setSortedData] = useState([]); // New state to store sorted data
  const [excelData, setExcelData] = useState([]);
  const [formInput, setFormInput] = useState({
    trafficMarshalId: "",
    trafficMarshalName: "",
    mobileNumber: "",
    emailId: "",
    operationTypeId: "",
    operationTypeName: "",
    isActive: true
  });
  const headers = ["trafficMarshalName", "mobileNumber", "emailId", "operationTypeName", "isActive", "actions"];

  const handleClose = () => {
    setLgShow(false);
    setFormSubmitted(false);
    setEditTrafficMarshalData("");
    setFormInput({
      trafficMarshalName: "",
      mobileNumber: "",
      emailId: "",
      operationTypeId: "",
      operationTypeName: "",
      isActive: "",
    });
  };


  useEffect(() => {
    const fetchOperationTypes = async () => {
      try {
        const data = await GetOperationTypes();
        setOperations(data);
      } catch (error) {
        console.error('Error fetching operation types:', error);
      }
    };

    fetchOperationTypes();
  }, []);


  const fetchData = async () => {
    try {
      const data = await GetTrafficMarshal();
      if (data === null) {
        setOriginalZones([]);
      } else {
        setOriginalZones(data);
        setIsOptionsLoading(false);
        setOriginalData(data)
      }
      const sortedCircleData = data.sort((a, b) => {
        if (a.isActive === b.isActive) {
          return 0;
        }
        return a.isActive ? -1 : 1;
      });
      setOriginalZones(sortedCircleData);
      setFilterOriginalTrafficMarshalData(sortedCircleData)
      console.log(sortedCircleData, "sortedCircleData");
    } catch (error) {
      console.error("Error fetching zones:", error);
    }
  };


  useEffect(() => {
    fetchData();
  }, []
  );


  const isValidEmail = (email) => {
    // Regular expression to validate email format
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const handleOperationTypeChange = (e) => {
    const { name, value } = e.target;
    const intValue = parseInt(value, 10);

    // Find the selected operation type object from operations array
    const selectedOperation = operations.find(
      (type) => type.operationTypeId === intValue
    );

    // Update formInput with the selected operation type ID and name
    setFormInput((prevData) => ({
      ...prevData,
      [name]: intValue,  // Update operationTypeId with the parsed integer value
      operationTypeName: selectedOperation
        ? selectedOperation.operationTypeName  // Correct property name for operation type name
        : "",  // Set to empty string if no selected operation type found
    }));
  };


  const handleInputChange = (e) => {
    const { name, value } = e.target;

    let sanitizedValue = value
      .replace(/^\s+/, "") // Remove leading spaces
      .replace(/\s{2,}/g, " ") // Replace multiple spaces with a single space
      .replace(/[^A-Za-z0-9\s-]/g, ""); // Allow only alphabets, numbers, hyphens (-), and spaces

    if (sanitizedValue.length > 42) {
      sanitizedValue = sanitizedValue.slice(0, 42); // Limit to 42 characters
    }

    setFormInput((prevData) => ({ ...prevData, [name]: sanitizedValue }));
  };

  const handleMobilenumberChange = (e) => {
    const { name, value } = e.target;
    
    // Remove non-numeric characters
    let sanitizedValue = value.replace(/\D/g, '');
  
    // Ensure the first digit is not 0-5
    if (/^[0-5]/.test(sanitizedValue)) {
      sanitizedValue = ""; // Clear input if first digit is invalid
    } else {
      sanitizedValue = sanitizedValue.slice(0, 10); // Limit to 10 digits
    }
  
    // Update state only if the number is valid
    setFormInput({ ...formInput, [name]: sanitizedValue });
  };
  
  const handleStatusChange = (e) => {
    const { name, value } = e.target;
    setFormInput((prevData) => ({
      ...prevData,
      // [name]: value === "true" ? true : false,
      [name]: value === "true",
    }));
  };

  const handleCreateTrafficMarshal = async (e) => {
    e.preventDefault();
    setFormSubmitted(true);

    // Check if required fields are populated
    if (!formInput.trafficMarshalName || !formInput.mobileNumber || !formInput.emailId || !formInput.operationTypeId || !formInput.operationTypeName) {
      console.log('Required fields are missing:', {
        trafficMarshalName: formInput.trafficMarshalName,
        mobileNumber: formInput.mobileNumber,
        emailId: formInput.emailId,
        operationTypeId: formInput.operationTypeId,
        operationTypeName: formInput.operationTypeName,
      });
      return; // Avoid calling the API if any required field is missing
    }

    try {
      setIsOptionsLoading(true);

      const requestBody = {
        trafficMarshalName: formInput.trafficMarshalName,
        mobileNumber: formInput.mobileNumber,
        emailId: formInput.emailId,
        isActive: formInput.isActive !== undefined ? formInput.isActive : true,
        operationTypeId: formInput.operationTypeId,
        operationTypeName: formInput.operationTypeName,
      };


      const response = editTrafficMarshalData
        ? await UpdateTrafficMarshalDetails({ ...requestBody, trafficMarshalId: editTrafficMarshalData.trafficMarshalId })
        : await CreateTrafficMarshalDeatails(requestBody);

      if (editTrafficMarshalData) {
        setOriginalZones(orginalZones.map(trafficmarshal => trafficmarshal.trafficMarshalId === response.trafficMarshalId ? response : trafficmarshal));
        toast.success('Traffic Marshal updated Successfully!');
      } else {
        setOriginalZones([...orginalZones, response]);
        toast.success('Traffic Marshal added Successfully!');
      }

      fetchData();
      handleClose();
    } catch (error) {
      console.error('API call failed:', error);
      if (error.response) {
        const { status, data } = error.response;
        const errorMessage = data || 'An error occurred';
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
        });
      }
    } finally {
      setIsOptionsLoading(false);
    }
  };

  useEffect(() => {
    setFormInput(
      editTrafficMarshalData || {
        trafficMarshalName: "",
        mobileNumber: "",
        emailId: "",
        operationTypeId: "",
        operationTypeName: "",
        isActive: true,
      }
    );
  }, [editTrafficMarshalData]);

  const handleShow = () => {
    setLgShow(true);
    setIsOptionsLoading(true);
    setTimeout(() => {
      setIsOptionsLoading(false);
    }, 1000);
    setEditTrafficMarshalData(null);
    if (orginalZones.length > 0) {
      setFormInput({
        trafficMarshalName: "",
        mobileNumber: "",
        emailId: "",
        operationTypeId: "",
        operationTypeName: "",
        isActive: true
      });
    } else {
      // If there are no zones available, set zoneId to an empty string
      setFormInput({
        trafficMarshalName: "",
        mobileNumber: "",
        emailId: "",
        operationTypeId: "",
        operationTypeName: "",
        isActive: true
      });
    }
  };

  const handleEditTrafficMarshal = (selectedTrafficMarshal) => {
    selectedTrafficMarshal.trafficMarshalName = selectedTrafficMarshal.trafficMarshalName.replace(
      /\s*\[[^\]]*]/,
      ""
    );
    setEditTrafficMarshalData(selectedTrafficMarshal);
    setLgShow(true);
    setIsOptionsLoading(true);
    setTimeout(() => {
      setIsOptionsLoading(false);
    }, 1000);
    setFormInput({
      trafficMarshalName: selectedTrafficMarshal?.trafficMarshalName,
      mobileNumber: selectedTrafficMarshal?.mobileNumber,
      emailId: selectedTrafficMarshal?.emailId,
      operationTypeId: selectedTrafficMarshal?.operationTypeId,
      operationTypeName: selectedTrafficMarshal?.operationTypeName,
      isActive: selectedTrafficMarshal?.isActive,
    });
  };

  const handleSort = (sortConfig) => {
    // Assuming you have a method to sort data based on sortConfig
    const sorted = [...orginalZones].sort((a, b) => {
      if (sortConfig.order === 'asc') {
        return a[sortConfig.column] > b[sortConfig.column] ? 1 : -1;
      } else {
        return a[sortConfig.column] < b[sortConfig.column] ? 1 : -1;
      }
    });

    setSortedData(sorted); // Update the sorted data
  };

  const handleSortAndExport = async () => {
    if (sortConfig) {
      handleSort(sortConfig); // Apply sorting
      await new Promise((resolve) => setTimeout(resolve, 100)); // Wait for state update
    }
    const dataToExport = sortConfig ? sortedData : originalData; // Use sorted or original data
    downloadAsExcel(dataToExport); // Export the data
  };

  const options = { day: 'numeric', month: 'numeric', year: 'numeric' };
  const generationTime = ` ${new Date().toLocaleString('en-GB', options).replace(/\//g, '/')}`;
  const downloadAsExcel = async () => {
    // Create a new workbook and add a worksheet
    const dataToUse = sortedData.length > 0 ? sortedData : originalData;
    const currentDate = new Date();
    const formattedDate = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1
      }-${currentDate.getDate()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const downloadDateTime = `Traffic Marshal Report Generated on: ${generationTime},${formattedTime}`;
    // Calculate the length of the downloadDateTime string
    const downloadDateTimeLength = downloadDateTime.length;
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Traffic Marshal");

    // Define styles
    const boldFont = { bold: true };

    // Add the downloadDateTime to the correct row and columns, and ensure formatting
    worksheet.addRow(["", "", downloadDateTime, ""]); // Update array length to match new cell range
    worksheet.mergeCells(1, 2, 1, 5); // Merge cells for downloadDateTime from column 2 to 4
    worksheet.getCell(1, 2).value = downloadDateTime; // Ensure the value is set after merging
    worksheet.getCell(1, 2).font = boldFont; // Set font style
    worksheet.getCell(1, 2).alignment = { horizontal: "center" }; // Center align the content

    // Apply styles to the merged cells (B1, C1, D1)
    for (let col = 2; col <= 5; col++) {
      worksheet.getCell(1, col).font = boldFont; // Set styles individually
      worksheet.getCell(1, col).alignment = { horizontal: "center" }; // Center align the cell content
    }

    // Add "Zone Details" to the correct row and columns, and ensure formatting
    worksheet.addRow(["", "", "Traffic Marshal Details", ""]); // Update array length to match new cell range
    worksheet.mergeCells(2, 2, 2, 5); // Merge cells for Zone Details from column 2 to 4
    worksheet.getCell(2, 2).value = "Traffic Marshal Details"; // Ensure the value is set after merging
    worksheet.getCell(2, 2).font = boldFont; // Set font style
    worksheet.getCell(2, 2).alignment = { horizontal: "center" }; // Center align the content

    // Apply styles to the merged cells (B2, C2, D2)
    for (let col = 2; col <= 5; col++) {
      worksheet.getCell(2, col).font = boldFont; // Set styles individually
      worksheet.getCell(2, col).alignment = { horizontal: "center" }; // Center align the cell content
    }

    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Traffic Marshal Name",
      "Mobile Number",
      "EmailId",
      "Operation Type Name",
      "Is Active"
    ]);
    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left", color: "#fff" }; // Center align the cell content
      if (colNumber >= 1 && colNumber <= 6) {
        // Apply background color and set text color
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" }, // Red background color
          bgColor: { argb: "FFFFFFFF" } // White text color
        };
      }
    });

    // Add data rows
    dataToUse.forEach((item, index) => {

      worksheet
        .addRow([
          index + 1,
          item.trafficMarshalName,
          item.mobileNumber,
          item.emailId,
          item.operationTypeName,
          item.isActive ? 'Active' : 'InActive',
        ])
        .eachCell({ includeEmpty: true }, (cell, colNumber) => {
          if (colNumber >= 1 && colNumber <= 5) {
            // Align the columns from 1 to 4 to the left
            cell.alignment = { horizontal: "left" };
          } else {
            // Align the rest of the columns to the center
            cell.alignment = { horizontal: "left" };
          }
        });
    });

    // Add total row with bold font


    // Set column widths dynamically based on content
    worksheet.columns = [
      { width: 5 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 15 },
      { width: 15 },
      { width: 20 },
    ];

    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "TrafficMarshalDetails.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };

  let storedPermissions = localStorage.getItem('permissionId')
  const permissionValues1 = JSON.parse(localStorage.getItem('rolePermissions')) || {};
  let canWriteValue = null;

  // Convert storedPermissions to a number (if needed)
  storedPermissions = parseInt(storedPermissions, 10);

  // Find the matching roleToPermissionMapping object
  const matchingPermission = permissionValues1.find(mapping => mapping.permissionId === storedPermissions);

  if (matchingPermission) {
    canWriteValue = matchingPermission.canWrite;
    console.log(`canWrite value for permission ID ${storedPermissions}:`, canWriteValue);
  } else {
    console.log(`No match found for permission ID ${storedPermissions}`);
  }

  const searchTrafficMarshalHandler = (e) => {
    const term = e.target.value.toLowerCase();
    const data = filterOriginalTrafficMarshalData.filter(item => item?.trafficMarshalName?.toLowerCase()?.includes(term) || item?.mobileNumber?.toLowerCase()?.includes(term))
    setOriginalZones(data);
  }

  return (
    <>
      {/* <Body/> */}
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <h4 class="text-start mb-3">{t("Traffic Marshal")}</h4>
            <div className="row mt-3 align-items-center">
              <div className="col-md-3">
                <input
                  placeholder="Traffic Marshal Name & Mobile Number"
                  type="text"
                  className="form-control bg-white"
                  onInput={searchTrafficMarshalHandler}
                />
              </div>
              <div className="col-md-9">
                <div className="d-flex justify-content-end">
                  {canWriteValue === true ?
                    <button className="button-container" onClick={handleShow}>
                      <i className="fa-solid fa-plus me-1 icon-container"></i>
                      {t("Add Traffic Marshal")}
                    </button>
                    : ""}
                  <button className="btn btn-excel"
                    onClick={handleSortAndExport}>
                    <i class="fa-solid fa-file-excel me-1 icon-container"></i> Excel
                  </button>
                </div>
              </div>
            </div>
            <div className="card mt-3">
              <div className="card-body">
                <TableComponent isLoading={isOptionsLoading}
                  DataFetchURL={orginalZones}
                  headers={headers}
                  filterFunction={(data) =>
                    data.filter(
                      (item) => item.status === 1 || item.status === 2
                    )
                  }
                  editData={handleEditTrafficMarshal}
                  editTrafficMarshalData={editTrafficMarshalData}
                  //viewData={(id) => handleViewCircleData(id)}
                  onSort={handleSort}
                />
                {/* ) : (
                        <div>No data found</div>
                      )
                    )} */}
              </div>
            </div>

          </div>
        </div>
      </div>
      <Modal
        size="lg"
        show={lgShow}
        onHide={() => setLgShow(false)}
        aria-labelledby="example-modal-sizes-title-lg"
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title id="example-modal-sizes-title-lg">
            {editTrafficMarshalData ? t("Edit Traffic Marshal") : t("Add Traffic Marshal")}
          </Modal.Title>
          <i
            class="fa-solid fa-xmark close-container"
            onClick={handleClose}
          ></i>
        </Modal.Header>
        <hr />
        <Modal.Body>
          <form>
            <div className="row">
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label">
                    Traffic Marshal Name
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <input
                    type="text"
                    className={`form-control ${formInput.circleName || !formSubmitted ? "" : "input-error"
                      }`}
                    value={formInput.trafficMarshalName}
                    placeholder="Enter Traffic Marshal Name"
                    name="trafficMarshalName"
                    onChange={handleInputChange}
                    maxLength={42}
                    disabled={!canWriteValue}
                  />
                  {!formInput.trafficMarshalName && formSubmitted && (
                    <div className="required-message small">
                      Traffic Marshal is Required
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group ">
                  <label className="form-label">Email ID <span style={{ color: "#EC1117" }}> *</span></label>
                  <input
                    type="email"
                    name="emailId"
                    placeholder="Enter Email ID"
                    className={`form-control ${formInput.emailId || !formSubmitted ? "" : "input-error"
                      }`}
                    onChange={(e) =>
                      setFormInput({ ...formInput, emailId: e.target.value })
                    }
                    value={formInput.emailId}
                    required
                    disabled={!canWriteValue}
                  />
                  {!formInput.emailId && formSubmitted && (
                    <div className="required-message small">
                      Email ID is Required
                    </div>
                  )}
                  {formInput.emailId && !isValidEmail(formInput.emailId) && (
                    <div className="required-message small">
                      Invalid Email Format
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group ">
                  <label className="form-label">Mobile Number <span style={{ color: "#EC1117" }}> *</span></label>
                  <input
                    //  type="number"
                    name="mobileNumber"
                    placeholder="Enter Mobile Number"
                    pattern="[0-9]{10}" // Specify the pattern for 10 digits
                    title="Mobile number must be exactly 10 digits long."
                    className={`form-control ${formInput.mobileNumber || !formSubmitted ? "" : "input-error"
                      }`}
                    onChange={handleMobilenumberChange}
                    value={formInput.mobileNumber}
                    disabled={!canWriteValue}
                  />
                  {!formInput.mobileNumber && formSubmitted && (
                    <div className="required-message small">
                      Mobile Number is Required
                    </div>
                  )}

                  {formInput.mobileNumber && formInput.mobileNumber.length !== 10 && formSubmitted && (
                    <div className="required-message small">
                      Mobile number must be 10 digits
                    </div>
                  )}

                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label">
                    Select Operation Type {" "}
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <select
                    className={`form-select ${formInput.operationTypeId || !formSubmitted ? "" : "input-error"
                      }`}
                    // value={selectedZone ? selectedZone.zone_id : ""}
                    value={formInput.operationTypeId}
                    name="operationTypeId"
                    onChange={handleOperationTypeChange}
                    disabled={!canWriteValue}
                  >
                    <option value="">Select</option>
                    {operations?.map((operation) => (
                      <option key={operation.operationTypeId} value={operation.operationTypeId}>
                        {operation.operationTypeName}
                      </option>
                    ))}
                  </select>
                  {!formInput.operationTypeId && formSubmitted && (
                    <div className="required-message small">
                      Operation Type is Required
                    </div>
                  )}
                </div>
              </div>
            
            <div className="col-md-4 form-group">
              <label className="form-label">Status<span style={{ color: '#EC1117' }}> *</span></label>
              <div className="form-group" style={{ display: "flex" }}>
                <div className="form-check">
                  <input
                    type="radio"
                    className="form-check-input"
                    name="isActive"
                    id="activeRadio"
                    value="true"
                    checked={formInput.isActive === true} // Check if isActive is true
                    onChange={handleStatusChange}
                  // onChange={() =>
                  //   handleInputChange({
                  //     target: { name: "isActive", value: true }, // Pass true when checked
                  //   })
                  // }
                  />
                  <label className="form-check-label" htmlFor="activeRadio">
                    Active
                  </label>
                </div>
                <div className="form-check" style={{ marginLeft: "40px" }}>
                  <input
                    type="radio"
                    className="form-check-input"
                    name="isActive"
                    value="false"
                    id="inactiveRadio"
                    checked={formInput.isActive === false}
                    // onChange={() =>
                    //   handleInputChange({
                    //     target: { name: "isActive", value: false }, // Set value to false
                    //   })
                    // }
                    onChange={handleStatusChange}
                  />

                  <label className="form-check-label" htmlFor="inactiveRadio">
                    InActive
                  </label>
                </div>
              </div>
            </div>
            </div>
            {/* )} */}
            <div className="modal-footer d-flex justify-content-center">
              {canWriteValue === true ?
                <button
                  type="button"
                  className="deployment-button"
                  onClick={handleCreateTrafficMarshal}
                >
                  <i class="fa-solid fa-check done-container"></i>
                  {editTrafficMarshalData ? t("Update") : t("Save")}
                </button>
                : ''}
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default withTranslation()(TrafficMarshal);